import * as React from "react";
import { singleton } from "logic/singleton";
const FormWarningsContext = React.createContext(void 0);
export default singleton("contexts.FormWarningsContext", () => FormWarningsContext);
